/**
 * AJAX Section Reload for Diamond Shape & Info Toggle links
 * Intercepts clicks on a.diamond-shape-link and a.info-toggle-switch__button
 * Reloads only the main-product section without full page navigation.
 */

(function () {
  'use strict';

  // ── Find section ID from marker attribute ─────────────────────────────────
  function getSectionId() {
    const el = document.querySelector('[data-ajax-section-id]');
    return el ? el.getAttribute('data-ajax-section-id') : null;
  }

  let isLoading = false;

  // ── Loader overlay ────────────────────────────────────────────────────────
  function showLoader() {
    const existing = document.getElementById('ajax-reload-loader');
    if (existing) return;
    const loader = document.createElement('div');
    loader.id = 'ajax-reload-loader';
    loader.style.cssText = [
      'position:fixed',
      'top:0','left:0','right:0','bottom:0',
      'z-index:99999',
      'background:rgba(255,255,255,0.35)',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'pointer-events:none',
    ].join(';');
    loader.innerHTML = '<div style="width:36px;height:36px;border:3px solid #071e40;border-top-color:transparent;border-radius:50%;animation:ajaxSpin 0.7s linear infinite"></div>';
    if (!document.getElementById('ajax-spin-style')) {
      const st = document.createElement('style');
      st.id = 'ajax-spin-style';
      st.textContent = '@keyframes ajaxSpin{to{transform:rotate(360deg)}}';
      document.head.appendChild(st);
    }
    document.body.appendChild(loader);
  }

  function hideLoader() {
    const el = document.getElementById('ajax-reload-loader');
    if (el) el.remove();
  }

  // ── Destroy Splide instances inside a container ───────────────────────────
  function destroySplides(container) {
    container.querySelectorAll('.splide').forEach(function (el) {
      if (el.splide && typeof el.splide.destroy === 'function') {
        try { el.splide.destroy(true); } catch (e) { /* ignore */ }
      }
    });
  }

  // ── Destroy Alpine components inside a container ──────────────────────────
  function destroyAlpine(container) {
    if (!window.Alpine) return;
    // Alpine 3 stores component data on __x; cleaning prevents double-init
    container.querySelectorAll('[x-data]').forEach(function (el) {
      if (el._x_dataStack) {
        try { Alpine.destroyTree && Alpine.destroyTree(el); } catch (e) { /* ignore */ }
      }
    });
  }

  // ── Re-init Alpine on new DOM ─────────────────────────────────────────────
  function reinitAlpine(container) {
    if (!window.Alpine) return;
    try {
      if (typeof Alpine.initTree === 'function') {
        Alpine.initTree(container);
      }
    } catch (e) {
      console.warn('[AJAX Reload] Alpine.initTree error:', e);
    }
  }

  // ── Re-init carat slider ──────────────────────────────────────────────────
  function reinitCaratSlider(container) {
    // Reset init flags so the observer picks them up fresh
    container.querySelectorAll('[data-option-name]').forEach(function (el) {
      el._caratSliderInit = false;
    });
    container.querySelectorAll('fieldset').forEach(function (el) {
      el._caratSliderInit = false;
    });

    // If carat slider bootstrap function is exposed globally, call it
    // Otherwise dispatch a custom event the snippet can listen for
    if (typeof window.__initCaratSlider === 'function') {
      window.__initCaratSlider(container);
    } else {
      // The MutationObserver inside carat_slider.liquid will detect
      // the newly added fieldsets automatically because _caratSliderInit
      // was reset above. Trigger a tiny DOM poke to ensure it fires.
      const ghost = document.createElement('span');
      ghost.style.display = 'none';
      container.appendChild(ghost);
      requestAnimationFrame(function () { ghost.remove(); });
    }
  }

  // ── Re-init Info Toggle Switch ────────────────────────────────────────────
  function reinitInfoToggle(container) {
    container.querySelectorAll('.info-toggle-switch').forEach(function (root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const buttons = root.querySelectorAll('[data-option]');
      const selectedLabel = root.querySelector('[data-selected-label]');
      const modal = root.querySelector('[data-info-modal]');
      const openButton = root.querySelector('[data-info-open]');
      const closeButtons = root.querySelectorAll('[data-info-close]');

      // Read labels from the rendered button text (avoids needing Liquid vars here)
      const labels = {};
      buttons.forEach(function (btn) {
        labels[btn.dataset.option] = btn.textContent.trim();
      });

      buttons.forEach(function (button) {
        button.addEventListener('click', function () {
          const option = button.dataset.option;
          buttons.forEach(function (item) {
            const selected = item.dataset.option === option;
            item.classList.toggle('is-selected', selected);
            item.setAttribute('aria-pressed', selected ? 'true' : 'false');
          });
          if (selectedLabel) selectedLabel.textContent = labels[option];
          root.dispatchEvent(new CustomEvent('info-toggle-change', {
            bubbles: true,
            detail: { option, label: labels[option] }
          }));
        });
      });

      if (!modal || !openButton) return;

      let lastFocusedElement = null;

      const openModal = function () {
        lastFocusedElement = document.activeElement;
        modal.hidden = false;
        document.documentElement.classList.add('info-toggle-modal-open');
        openButton.setAttribute('aria-expanded', 'true');
        const closeButton = modal.querySelector('.info-toggle-switch__close');
        if (closeButton) closeButton.focus();
      };

      const closeModal = function () {
        modal.hidden = true;
        document.documentElement.classList.remove('info-toggle-modal-open');
        openButton.setAttribute('aria-expanded', 'false');
        if (lastFocusedElement) lastFocusedElement.focus();
      };

      openButton.addEventListener('click', openModal);
      closeButtons.forEach(function (btn) {
        btn.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) {
        if (!modal.hidden && e.key === 'Escape') closeModal();
      });
    });
  }


  // ── Dispatch misc theme events after reload ───────────────────────────────
  function dispatchThemeEvents() {
    document.dispatchEvent(new CustomEvent('eurus:badges:loaded'));
    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
  }

  function reinitShippingDates(container) {
    var startEl = container.querySelector('#ship-start-date');
    var endEl = container.querySelector('#ship-end-date');
    if (!startEl || !endEl) return;

    function formatDate(d) {
      return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
    }

    var today = new Date();
    var startDate = new Date(today);
    startDate.setDate(startDate.getDate() + 12);
    var endDate = new Date(today);
    endDate.setDate(endDate.getDate() + 13);

    startEl.textContent = formatDate(startDate);
    endEl.textContent = formatDate(endDate);
  }

  // ── Re-attach link interceptors ───────────────────────────────────────────
  function attachInterceptors(root) {
    var selector = 'a.diamond-shape-link, a.info-toggle-switch__button';
    root.querySelectorAll(selector).forEach(function (link) {
      if (link.dataset.ajaxBound) return;
      link.dataset.ajaxBound = '1';
      link.addEventListener('click', onLinkClick);
    });
  }

  // ── Core: fetch section HTML and swap ────────────────────────────────────
  async function reloadSection(url) {
    var SECTION_ID = getSectionId();

    if (!SECTION_ID) {
      // Fallback: normal navigation
      window.location.href = url;
      return;
    }

    // The shopify-section wrapper that wraps the entire section output
    var shopifySectionEl = document.getElementById('shopify-section-' + SECTION_ID);

    if (!shopifySectionEl) {
      console.warn('[AJAX Reload] Cannot find #shopify-section-' + SECTION_ID + ', falling back.');
      window.location.href = url;
      return;
    }

    showLoader();

    try {
      // Shopify sections API: append ?sections=id
      var fetchUrl = url + (url.indexOf('?') !== -1 ? '&' : '?') + 'sections=' + encodeURIComponent(SECTION_ID);

      var response = await fetch(fetchUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }

      var json = await response.json();

      // Shopify returns { "section-id": "<html>..." }
      var sectionHTML = json[SECTION_ID];

      if (!sectionHTML || typeof sectionHTML !== 'string') {
        throw new Error('Section "' + SECTION_ID + '" not found in API response. Keys: ' + Object.keys(json).join(', '));
      }

      // Parse the returned HTML — it contains the full shopify-section div
      var parser = new DOMParser();
      var doc = parser.parseFromString(sectionHTML, 'text/html');

      // Shopify wraps content in <div id="shopify-section-XXXX" class="shopify-section">
      var newSectionEl = doc.getElementById('shopify-section-' + SECTION_ID);

      if (!newSectionEl) {
        // Sometimes the section HTML IS the inner content without the wrapper
        // In that case use the body content directly
        newSectionEl = doc.body;
      }

      if (!newSectionEl) {
        throw new Error('Cannot parse section HTML from response');
      }

      // ── Tear down existing instances ──────────────────────────────────
      destroySplides(shopifySectionEl);
      destroyAlpine(shopifySectionEl);

      // ── Replace HTML ──────────────────────────────────────────────────
      // Replace the outerHTML so the shopify-section wrapper itself is correct
      shopifySectionEl.outerHTML = newSectionEl.outerHTML;

      // Re-query because the DOM node was replaced
      var replacedSectionEl = document.getElementById('shopify-section-' + SECTION_ID);

      if (!replacedSectionEl) {
        throw new Error('Section disappeared after outerHTML swap');
      }
 
      // ── Re-initialize ─────────────────────────────────────────────────
      reinitAlpine(replacedSectionEl);
      reinitCaratSlider(replacedSectionEl);
      reinitInfoToggle(replacedSectionEl);
      reinitShippingDates(replacedSectionEl);
      dispatchThemeEvents();
      attachInterceptors(replacedSectionEl);

      // ── Update browser URL ────────────────────────────────────────────
      history.pushState({ ajaxReload: true }, '', url);

    } catch (err) {
      console.error('[AJAX Reload] Error, falling back to full navigation:', err);
      window.location.href = url;
    } finally {
      hideLoader();
      isLoading = false;
    }
  }

  // ── Click handler ─────────────────────────────────────────────────────────
  function onLinkClick(e) {
    // Allow modifier keys (new tab, etc.)
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var link = e.currentTarget;
    var href = link.href;

    if (!href) return;

    // Same origin only
    try {
      var parsed = new URL(href);
      if (parsed.origin !== window.location.origin) return;
      // Don't reload same exact URL
      if (parsed.pathname === window.location.pathname && parsed.search === window.location.search) {
        e.preventDefault();
        return;
      }
    } catch (err) {
      return;
    }

    e.preventDefault();
    if (isLoading) return;
    isLoading = true;

    reloadSection(href);
  }

  // ── MutationObserver to catch dynamically added links ─────────────────────
  function watchForLinks() {
    var observer = new MutationObserver(function () {
      var SECTION_ID = getSectionId();
      if (!SECTION_ID) return;
      var root = document.getElementById('shopify-section-' + SECTION_ID) || document.body;
      attachInterceptors(root);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ── Bootstrap ─────────────────────────────────────────────────────────────
  function init() {
    var SECTION_ID = getSectionId();
    if (!SECTION_ID) {
      // data-ajax-section-id not present — feature disabled
      return;
    }

    var root = document.getElementById('shopify-section-' + SECTION_ID) || document.body;
    attachInterceptors(root);
    watchForLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();